import request from '../utils/request.js'

/**
 * 购物车下单接口
 * **/
export function orderSave(data) {
  return request({
    url: '/rest/cart/order/save',
    method: 'post',
    data
  })
}


/**
 * 购物车获取购物金
 * **/
export function availableConsume(amount,spuId,rcgiList) {
  return request({
    url: '/rest/recharge/availableConsume2?amount=' + amount + '&gidListStr=' + spuId,
    method: 'post',
    data: {
      rcgiList:rcgiList
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/order-cart.js